export default {
  isDefaultForLanguage: true,
  listenToThisArticle: "Dengarkan artikel ini",
  minutesSingularOrPlural: "{n} mnt",
  videoInWidget: "Video is playing in widget",

  // These translations are used by aria-label.
  playAudio: "Play audio",
  pauseAudio: "Pause audio",
  playbackTime: "Playback time",
  secondsSingular: "1 second",
  secondsPlural: "{n} seconds",
  minutesSingular: "1 minute",
  minutesPlural: "{n} minutes",
  outOfTotalTime: "out of total time",
  visitAdvert: "Visit advert",
  visitBeyondWords: "Visit BeyondWords",
  closeWidget: "Close widget",
  seekBack: "Seek back",
  seekAhead: "Seek ahead",
  previousSegment: "Previous segment",
  nextSegment: "Next segment",
  previousTrack: "Previous track",
  nextTrack: "Next track",
  togglePlaylist: "Toggle playlist",
  visitSourceArticle: "Visit source article",
  maximizeVideo: "Maximize video",
  changePlaybackRate: "Change playback rate",
  downloadAudio: "Download audio",
};
